// tslint:disable:jsx-no-multiline-js (autogenerated)
// tslint:disable:no-unsafe-any (autogenerated)
// tslint:disable:no-any (autogenerated)
import * as React from 'react';
import Color from 'color';
import Radium from '../styling/rostelecom-radium';
import SvgCheckbox from './svg-checkbox';

export interface ICheckboxProps extends IFormComponentProps {
    styles?: any;
    disabled?: boolean;
    display: string | React.ReactElement<any>;
    renderNativeCheckbox?: boolean;
    svgSize?: number;
    fontSize?: string;
    fontWeight?: any;
    checkMarkColor?: string;
    checkBoxColor?: string;
}

export interface ICheckboxState {
    value: boolean;
}

@Radium
class Checkbox extends React.Component<ICheckboxProps, ICheckboxState> {
    // tslint:disable-next-line:typedef (autogenerated)
    constructor(props, options) {
        super(props, options);
        this.state = { value: this.props.value || false };
    }

    // tslint:disable-next-line:member-access (autogenerated)
    onChange = () => {
        if (!this.props.disabled && this.props.onChange) {
            this.props.onChange(!this.state.value);
        }
    };

    // tslint:disable-next-line:typedef member-access (autogenerated)
    componentWillReceiveProps(newProps) {
        if (newProps.value !== this.props.value) {
            this.setState({ value: newProps.value });
        }
    }

    // tslint:disable-next-line:member-access (autogenerated)
    getStyle(): { [style: string]: React.CSSProperties } {
        const styleParams = this.props.styles;
        const {
            renderNativeCheckbox,
            svgSize = 17,
            fontSize = '12px',
            fontWeight = 'normal'
        } = this.props;
        return {
            outerDiv: {
                userSelect: 'none'
            } as React.CSSProperties,
            inputStyle: {
                transform: 'scale(1.4)',
                marginLeft: 3
            } as React.CSSProperties,
            label: {
                paddingLeftFix: renderNativeCheckbox ? 14 : 0,
                fontSize,
                fontWeight,
                color: Color(styleParams.neutralColor)
                    .darken(0.6)
                    .hexString(),
                cursor: 'pointer'
            } as React.CSSProperties,
            label__disabled: {
                paddingLeftFix: renderNativeCheckbox ? 14 : 0,
                fontSize,
                fontWeight,
                color: styleParams.neutralColor,
                cursor: 'pointer'
            } as React.CSSProperties,
            svgContainer: {
                display: renderNativeCheckbox ? 'none' : 'inline-block',
                widthFix: svgSize,
                heightFix: svgSize,
                marginRightFix: 10,
                position: 'relative',
                top: 3
            } as React.CSSProperties
        };
    }

    // tslint:disable-next-line:member-access typedef (autogenerated)
    render() {
        const styles = this.getStyle();
        const key = this.props.id;
        const id = 'checkbox_' + key;
        const {
            neutralColor,
            complementaryMediumDarkColor,
            complementaryAccentColor
        } = this.props.styles;

        const checkMarkColor = this.props.checkMarkColor || complementaryMediumDarkColor;
        const checkBoxColor = this.props.checkBoxColor || complementaryAccentColor;
        const isNativeCheckbox = this.props.renderNativeCheckbox;

        return (
            <div style={styles.outerDiv} key={key}>
                <input
                    type="checkbox"
                    id={id}
                    onChange={this.onChange}
                    disabled={this.props.disabled}
                    checked={this.state.value}
                    style={
                        isNativeCheckbox
                            ? styles.inputStyle
                            : { ...styles.inputStyle, display: 'none' }
                    }
                />
                <label
                    htmlFor={id}
                    style={this.props.disabled ? styles.label__disabled : styles.label}
                >
                    <div style={styles.svgContainer}>
                        <SvgCheckbox
                            {...{
                                disabled: this.props.disabled,
                                checked: this.state.value,
                                disabledColor: neutralColor,
                                checkMarkColor,
                                checkBoxColor
                            }}
                        />
                    </div>
                    {this.props.display}
                </label>
            </div>
        );
    }
}

// tslint:disable-next-line:no-default-export (autogenerated)
export default Checkbox;
